export default "/images/vendor/flag-icon-css/flags/4x3/qa.svg?90240e607800ce7ed1bdf42b580695bc";